import { Company } from '../../types';
import type { DbClient } from './types';

/**
 * Busca UUID da empresa pelo nome.
 * @param sb - Cliente API
 * @param name - Nome da empresa (Sanpack, Sanplast, etc.)
 */
export async function getCompanyId(sb: DbClient, name: Company): Promise<string | null> {
  const { data } = await sb.from('rh_companies').select('id').eq('name', name).single();
  return data?.id ?? null;
}

/**
 * Garante que a empresa existe no banco e retorna o UUID.
 * Upsert só quando a empresa ainda não existe (fluxo administrativo).
 * @param sb - Cliente API
 * @param name - Nome da empresa
 */
export async function ensureCompany(sb: DbClient, name: Company): Promise<string> {
  const existingId = await getCompanyId(sb, name);
  if (existingId) return existingId;

  const { data, error } = await sb
    .from('rh_companies')
    .upsert({ name }, { onConflict: 'name' })
    .select('id')
    .single();
  if (error) throw error;
  return data.id;
}
